import * as Api from '@ViewModels';
import * as React from 'react';
import { normalizeFacebookPageHandle, useFacebookPageLookupQuery } from './useFacebookPageLookupQuery';

export function useFacebookPageAutoCompleteViewModel({
	enabled = true,
	impersonationContext,
}: {
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
} = {}) {
	const [searchQuery, setSearchQuery] = React.useState('');
	const normalizedHandle = normalizeFacebookPageHandle(searchQuery);
	const lookupQuery = useFacebookPageLookupQuery({
		handle: normalizedHandle,
		enabled,
		impersonationContext,
	});

	const searchResults = React.useMemo(() => (lookupQuery.data?.pageId ? [lookupQuery.data] : []), [lookupQuery.data]);

	return React.useMemo(
		() =>
			({
				isBusy: lookupQuery.isLoading || lookupQuery.isFetching,
				reset: () => setSearchQuery(''),
				searchResults,
				setSearchQuery: (value?: string) => setSearchQuery(value || ''),
				totalCount: searchResults.length,
			}) as Api.AutoCompleteViewModel<Api.IFacebookPageLookupResult>,
		[lookupQuery.isFetching, lookupQuery.isLoading, searchResults]
	);
}
